module.exports = __webpack_public_path__ + "static/media/golf4.e5c0c55a.jpg";